import { DI } from "../../../../apps/crossword-maker/src/shared/di";
import { 
    ICrosswordBookApiRequestData, 
    ICrosswordBookApiResponse,
    ICreateCrosswordBookWordDto,
    IUpdateCrosswordBookWordDto,
    ICrosswordBookWordEntity,
    ICrosswordBookWordCategoryWithWord
} from "../../Api/CrosswordBook/CrosswordBook.api.types";
import { IReplaceCategoryDataType } from "../../Api/CrosswordBook/CrosswordBookReplaceCategories.api";
import { ICopyWordFromDictionaryPayload } from "../../Api/CrosswordBook";

export interface ICrosswordBookRepository {
	getManyWords(data?: ICrosswordBookApiRequestData): Promise<ICrosswordBookApiResponse>;
    createWord(data: ICreateCrosswordBookWordDto): Promise<ICrosswordBookWordEntity>;
    updateWord(id: string, data: IUpdateCrosswordBookWordDto): Promise<ICrosswordBookWordEntity>;
    deleteWord(id: string): Promise<void>;
    addCategoryToWordByValues(word: string, category: string): Promise<any>;
    deleteWordCategory(wordCategoryId: string): Promise<void>;
    replaceCategories(data: IReplaceCategoryDataType): Promise<ICrosswordBookWordCategoryWithWord[]>;
    copyFromDictionary(data: ICopyWordFromDictionaryPayload): Promise<ICrosswordBookWordEntity[]>;
}

export const CrosswordBookRepository = (): ICrosswordBookRepository => {
	const CrosswordBookApi = DI.resolve("CrosswordBookApi");

	return {
		async getManyWords(data) {
			return await CrosswordBookApi.getManyWords(data);
		},
        async createWord(data) {
            return await CrosswordBookApi.createWord(data);
        },
        async updateWord(id, data) {
            return await CrosswordBookApi.updateWord(id, data);
        },
        async deleteWord(id) {
            return await CrosswordBookApi.deleteWord(id);
        },
        async addCategoryToWordByValues(word, category) {
            return await CrosswordBookApi.addCategoryToWordByValues(word, category);
        },
        async deleteWordCategory(wordCategoryId) {
            return await CrosswordBookApi.deleteWordCategory(wordCategoryId);
        },
        async replaceCategories(data) {
            return await CrosswordBookApi.replaceCrosswordBookCategories(data);
        },
        async copyFromDictionary(data) {
            return await CrosswordBookApi.copyFromDictionary(data);
        }
	};
};
